import { render, staticRenderFns } from "./PositionMobile.vue?vue&type=template&id=547e18c6&scoped=true&"
import script from "./PositionMobile.vue?vue&type=script&lang=js&"
export * from "./PositionMobile.vue?vue&type=script&lang=js&"
import style0 from "./PositionMobile.vue?vue&type=style&index=0&id=547e18c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e18c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VLayout,VSkeletonLoader})
